import { Injectable } from "@angular/core";
import { CustomerJob } from "./customerjobs";
import { Observable, throwError, of, Subject, BehaviorSubject } from "rxjs";
import { retry, catchError, map, finalize, tap } from "rxjs/operators";
import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { MessagerComponent } from "src/app/messager/messager/messager.component";
import { Customer } from "src/app/customers/customers";

@Injectable({
  providedIn: "root",
})
export class CustomerJobService {
  private baseURL = environment.baseUrl;
  private subject = new BehaviorSubject<CustomerJob[]>([]);

  gridObject$: Observable<CustomerJob[]> = this.subject.asObservable();
  isLoading = true;

  constructor(private http: HttpClient, private messager: MessagerComponent) {}

  init() {
    const http$ = this.gridHttp();

    http$
      .pipe(
        tap(() => {
          this.isLoading = false;
        })
      )
      .subscribe((res) => this.subject.next(res.CustomerJobs));
  }

  saveEdit(id: number, changes): Observable<any> {
    const customerjobs = this.subject.getValue();

    const cjIndex = customerjobs.findIndex(
      (customerjob) => customerjob.customerjob_id === id
    );
    const newCJList = customerjobs.slice(0);


    newCJList[cjIndex] = {
      ...customerjobs[cjIndex],
      ...changes,
    };

    this.subject.next(newCJList);
    return this.http
      .post(this.baseURL + "/rhAPI/customerjobs/edit/" + id, changes)
      .pipe(
        tap((event) => {
          const message = event.Message as unknown as string;
          if (event.Error) {
            this.messager.openSnackBar(message, "Close", "errorAlert");
            this.subject.next(customerjobs);
          } else {
            this.messager.openSnackBar(message, "", "successAlert");
          }
        })
      );
  }

  getOne(id): Observable<any> {
    return this.http.get(this.baseURL + "/rhAPI/customerjobs/edit/" + id).pipe(
      tap((event) => {
        const message = event.Message as unknown as string;
        if (event.Error) {
          this.messager.openSnackBar(message, "Close", "errorAlert");
        } else {
          this.messager.openSnackBar(message, "Editing...", "successAlert");
        }
      })
    );
  }

  copy(row): Observable<any> {
    return this.http.post(this.baseURL + "/rhAPI/customerjobs/copy/" + row.customerjob_id, row).pipe(
      tap((event) => {
        const message = event.Message as unknown as string;
        if (event.Error) {
          this.messager.openSnackBar(message, "Close", "errorAlert");
        } else {
          this.messager.openSnackBar('Successfully Copied.', "Close", "successAlert");
        }
      })
    );
  }

  getInitial() {
    return this.gridObject$.pipe(map((objects) => objects));
  }

  getBaseURL() {
    return this.baseURL;
  }


  getCustomersDropdown(name: string): Observable<Customer[]> {

    return this.http.get<Customer[]>(this.baseURL + "/rhAPI/customers/" + name);
  }

  getRe(name: string): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/customerjobs/createRe/' + name);
  }

  gridHttp(): Observable<any> {
    return this.http.get<CustomerJob[]>(this.baseURL + "/rhAPI/customerjobs", {
      observe: "body",
    });
  }

  checkDuplicate(customer_name, job_type): Observable<any> {
      return this.http.get(this.baseURL + '/rhAPI/customerjobs/checkForDuplicates/' + customer_name + '/' + job_type, {observe: 'body'});
  }

  getJobTypes(name: string): Observable<any> {
    return this.http.get<any[]>(
      this.baseURL + "/rhAPI/customerjobs/getJobTypes/" + name
    );
  }

  // Card 6TSzF61V: the backend soft-deletes, so flip the row in place instead of
  // splicing it out — the grid re-renders it as Inactive rather than losing it.
  deleteOne(id: number) {
    const originalList = this.subject.getValue();
    const index = originalList.findIndex(
      (object) => object.customerjob_id === id
    );

    if (index === -1) { return; }

    const newList = originalList.slice(0);

    newList[index] = {
      ...originalList[index],
      inactivecustomerjob: true
    };
    this.subject.next(newList);
  }

  


  addOneFrontend(changes): void {

    const list = this.subject.getValue();
    const newList = list.slice(0);

    newList.unshift(changes);
    this.subject.next(newList);

  }

  add(changes): Observable<any> {

    return this.http
      .post(this.baseURL + "/rhAPI/customerjobs/create", changes)
      .pipe(
        tap((event) => {
          const message = event.Message as unknown as string;
          if (event.Error) {
            this.messager.openSnackBar(message, "Close", "errorAlert");
            //this.subject.next(list);
          } else {
            this.messager.openSnackBar(message, "", "successAlert");
          }
        })
      );

  }


  updateOtherQIs(customer_id: number, value: string): Observable<any> {
    return this.http.post(`${this.baseURL}/rhAPI/customers/updateOtherQIs/${customer_id}`, {"repemaildist" : value});
  }


}
